import Vue from 'vue';
import App from './App.vue';

Vue.config.performance = true;

//import wrap from '@vue/web-component-wrapper';

/**
 * Boilerplate to export app as a webcomponent
 * Not needed as of now
 */
// let isComponent = false;

// if (!isComponent) {

// } else {
// 	const WrappedElement = wrap(Vue, App);
// 	window.customElements.define('underline-me', WrappedElement);
// }

new Vue({
	render: h => h(App),
	methods: {},
	mounted: function() {}
}).$mount('#app');
